@if(isOpen) {
<div class="modal-backdrop-custom d-flex align-items-center justify-content-center" (click)="close()">
  <div class="modal-container-custom p-4" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="modal-header-custom d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
      <div>
        <h5 class="modal-title-custom fw-bold mb-1">Select Supervisor</h5>
        <span class="modal-subtitle-custom text-muted">Showing {{ targetLevelLabel }}</span>
      </div>
      <button type="button" class="btn-close-custom" (click)="close()" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor"
          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Search -->
    <div class="search-bar-custom mb-3 position-relative">
      <input type="text" class="form-control search-input-custom" placeholder="Search by name or role..."
        [(ngModel)]="searchQuery" name="supervisorSearch">
      <span class="search-icon-custom position-absolute">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="#a09ea5" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </span>
    </div>

    <!-- Body -->
    <div class="modal-body-custom">

      <!-- Loading State -->
      @if(loading) {
      <div class="state-container text-center py-4">
        <div class="spinner-ring mb-3">
          <div></div><div></div><div></div><div></div>
        </div>
        <p class="text-muted small mb-0">Loading supervisors…</p>
      </div>
      }

      <!-- Error State -->
      @else if(error) {
      <div class="state-container text-center py-4">
        <div class="state-icon-wrap error-icon mb-3">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#E53E3E" class="bi bi-exclamation-circle"
            viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
            <path
              d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
          </svg>
        </div>
        <p class="text-danger small mb-2">{{ error }}</p>
        <button type="button" class="btn btn-sm btn-outline-secondary px-3" (click)="retry()">Try again</button>
      </div>
      }

      <!-- Supervisor List -->
      @else {
      <div class="supervisor-list-custom d-flex flex-column gap-2">
        @for (s of filteredSupervisors; track s.id) {
        <div class="supervisor-item-custom d-flex align-items-center justify-content-between p-3"
          [class.active]="selectedSupervisorId === s.id" (click)="select(s)">
          <div class="d-flex align-items-center gap-3">
            <div class="avatar-circle-custom">{{ s.name | initials }}</div>
            <div>
              <div class="supervisor-name-custom fw-bold">{{ s.name }}</div>
              <div class="supervisor-role-custom text-muted small">{{ s.role }}</div>
            </div>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span class="badge badge-reports-custom">{{ s.directReports || 0 }} reports</span>
            @if(selectedSupervisorId === s.id) {
            <span class="check-icon-custom">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#00D1D2" class="bi bi-check-lg"
                viewBox="0 0 16 16">
                <path
                  d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
              </svg>
            </span>
            }
          </div>
        </div>
        } @empty {
        <div class="state-container text-center py-4">
          <div class="state-icon-wrap mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#a09ea5"
              class="bi bi-person-slash" viewBox="0 0 16 16">
              <path
                d="M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465zm.707.707-3.172 3.172a2.501 2.501 0 0 0 3.172-3.172M14 7.5a3.5 3.5 0 0 1-.646 2.04L13 9.185A2.5 2.5 0 0 0 13 7.5V7a5 5 0 0 0-4.5-4.975V1h-1v1.025A5 5 0 0 0 3 7v.5c0 .818.393 1.544 1 2V11H3a3 3 0 0 0-3 3v1h7.14a3.501 3.501 0 0 0 4.872-4.872L14 7.5z" />
            </svg>
          </div>
          @if(searchQuery.trim()) {
          <p class="text-muted small mb-0">No results for "<strong>{{ searchQuery }}</strong>"</p>
          } @else {
          <p class="text-muted small mb-0">No supervisors available at this level.</p>
          }
        </div>
        }
      </div>
      }

    </div>

    <!-- Footer -->
    <div class="modal-footer-custom d-flex justify-content-end mt-3 pt-3 border-top">
      <button type="button" class="btn btn-outline-secondary btn-sm px-4" (click)="close()">Cancel</button>
    </div>

  </div>
</div>
}
